<template><div class="main">
  <sticky-bar
      search="search by unit name"
      v-model="filterUnitName"
      @accept="acceptFilter"
      @filter="showFilter=$event"
      :filterIcon="$store.state.filterFleetId && 'filter_1'"
      >
    Diagnostics
  </sticky-bar>
  <div class="split">
    <div class="list" v-if="showFilter"
        @click="$store.commit('selectPoi', null)"
        >
      <div class="flex-toolbar">
        <select v-model="filterFleetId">
          <option :value="null">All</option>
          <option
              v-for="f of $store.state.permissions.fleets"
              :key="`f-${f.id}`"
              v-html="f.name"
              :value="f.id"
            />
        </select>
        <a href="#" @click.prevent="poiList=false" :class="{active:!poiList}">Units</a>
        <a href="#" @click.prevent="poiList=true" :class="{active:poiList}">POIs</a>
      </div>
      <div class="of1">
        <div class="of2">
          <div class="units" v-if="!poiList">
            <unit-button
                v-for="uid in uids"
                :key="`unit-${uid}`"
                :uid="uid"
              />
          </div>
          <div class="pois" v-else>
            <a
                v-for="(poi,i) in pois"
                :key="`poi-${i}`"
                v-html="poi.name"
                @click.stop="$store.commit('selectPoi',poi.id)"
                :class="{selected:poi.id===selectedPoi}"
                v-show="is_pid_visible(poi.id)"
              />
          </div>
        </div>
      </div>
    </div>
    <div class="map"><g-map key="gmapcomp" /></div>
  </div>
</div></template>
<script>
import { mapState, mapGetters } from 'vuex'
import GMap from './GMap'
import StickyBar from './StickyBar'
import UnitButton from './UnitButton'
export default {
  name: 'home',
  components: {
    GMap,
    StickyBar,
    UnitButton,
  },
  data() {
    return {
      poiList: false,
      showFilter: false,
    }
  },
  computed: {
    ...mapState(['user','selectedPoi','uids_sorted_by_name']),
    ...mapGetters(['myManagedFleets','fleets','is_pid_visible']),
    filterUnitName: {
      get() { return this.$store.state.filterUnitName },
      set(nv) { this.$store.commit('setFilterUnitName', nv) },
    },
    filterFleetId: {
      get() { return this.$store.state.filterFleetId },
      set(nv) { this.$store.commit('setFilterFleetId', nv) },
    },
    uids() { return this.uids_sorted_by_name },
    pois() {
      let pois = []
      for (const fid in this.fleets) {
        pois.push(...this.fleets[fid].pois)
      }
      pois.sort((a,b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
      return pois
    },
  },
  methods: {
    acceptFilter() {
      document.activeElement.blur()
    },
    clickUnit(uid) {
      this.$router.push(`/u/${uid}/s`)
    },
  },
  watch: {
    /*
    TODO navigate to the proper view right away...
    '$store.accessible_units': function(nv,ov) {
      if (ov === null && nv.length === 0) {
        if (this.myManagedFleets.length)
          this.$router.push('/administration')
        else if (this.user && this.user.accounts && this.user.accounts.length)
          this.$router.push('/billing')
        else if (this.user && this.user.is_staff)
          this.$router.push('/provisioning')
        else if (this.user)
          this.$router.push('/preferences')
      }
    },
    */
  },
}
</script>
<style lang="scss" scoped>

  .main {
    overflow: hidden;

    > .split {
      display: flex;
      flex-direction: column;
      overflow-y: hidden;

      > .list {
        max-height: 40%;
        border-bottom: 1px solid #000;
        display: flex;
        flex-direction: column;
        .of1 {
          display: flex;
          flex: 1;
          min-height: 0px;
          .of2 {
            flex: 1;
            overflow: auto;
          }
        }
      }
      > .map {
        flex-grow: 1;
      }
    }
  }



  .units, .pois {
    padding: 10px 5px 5px 10px;
    display: flex;
    flex-wrap: wrap;
    align-content: stretch;
    a {
      white-space: nowrap;
      flex: 1 0 0;
      background: #bbb;
      border-radius: 5px;
      margin: 0 5px 5px 0;
      padding: 5px 10px;
      cursor: pointer;
      &:hover { background: #ccc; }
      &.selected { background: #4f4; }
    }
  }

  @media (min-width: 1400px) {
    .main {
      > .split {
        flex-direction: row;
        > .list {
          order: 2;
          max-height: none;
          max-width: 400px;
          border-bottom: none;
        }
        > .map {
          order: 1;
        }
      }
    }
  }


</style>
